<template>
  <MainLayout>
    <ContentPageHeader functionName="商品管理" pageName="メーカー管理">
    </ContentPageHeader>
    
    <div class="card mb-4">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="input-group" style="max-width: 600px;">
            <input 
              type="text" 
              v-model="newMakerName" 
              class="form-control" 
              placeholder="メーカー名を入力"
            />
            <button 
              class="btn btn-primary" 
              @click="registerMaker"
            >
              新規作成
            </button>
          </div>
        </div>
        
        <FormDraggableList
          v-model:items="makers"
          :columns="columns"
          @order-changed="updateDisplayOrder"
          @save-edit="updateMaker"
          @delete-item="deleteMaker"
          :disableDelete="isStaff"
        />
      </div>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layout/MainLayout.vue'
import ContentPageHeader from '@/components/layout/ContentPageHeader.vue'
import FormDraggableList from '@/components/form/FormDraggableList.vue'
import service from '../../services/service';
import { showLoading, hideLoading } from '@/utils/loadingEventBus';
import constants from '../../constants/constants.json';

export default {
  name: 'ManufacturerView',
  components: {
    MainLayout,
    ContentPageHeader,
    FormDraggableList
  },
  data() {
    return {
      makers: [],
      columns: [
        { key: 'drag', label: '', style: { width: '40px' } },
        { key: 'maker', label: 'メーカー名' }
      ],
      newMakerName: ''
    }
  },
  computed: {
    isStaff() {
      return this.$store.getters['auth/currentUser']?.authority === constants.Authority.STAFF.id;
    }
  },
  mounted() {
    this.fetchMakers();
  },
  methods: {
    // メーカー一覧取得
    async fetchMakers() {
      try {
        showLoading();
        const response = await service.getMakerList();
        this.makers = response.data.makers;
      } catch (error) {
        console.error('メーカー一覧の取得に失敗しました', error);
        alert('メーカー一覧の取得中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    },
    
    // メーカー登録
    async registerMaker() {
      // 入力値が空の場合はアラートを表示
      if (!this.newMakerName.trim()) {
        alert('メーカー名を入力してください');
        return;
      }
      if (64 < this.newMakerName.length) {
        alert('メーカー名は64文字以内で入力してください');
        return;
      }
      
      // 確認ダイアログを表示
      const confirmed = confirm(`「${this.newMakerName}」を登録してもよろしいですか？`);
      if (!confirmed) return;
      
      try {
        showLoading();
        await service.registerMaker({
          maker: this.newMakerName
        });
        
        this.newMakerName = '';
        await this.fetchMakers();
      } catch (error) {
        console.error('メーカー登録に失敗しました', error);
        alert('メーカー登録中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    },
    
    // メーカー更新
    async updateMaker(maker) {
      // 入力値が空または65文字以上の場合はアラートを表示
      if (!maker.maker || !maker.maker.trim()) {
        alert('メーカー名を入力してください');
        return;
      }
      if (64 < maker.maker.length) {
        alert('メーカー名は64文字以内で入力してください');
        return;
      }
      try {
        showLoading();
        await service.updateMaker(maker.id, {
          maker: maker.maker
        });
        
        await this.fetchMakers();
      } catch (error) {
        console.error('メーカー更新に失敗しました', error);
        alert('メーカー更新中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    },
    
    // メーカー削除
    async deleteMaker(maker) {
      try {
        showLoading();
        await service.deleteMaker(maker.id);
        
        await this.fetchMakers();
      } catch (error) {
        console.error('メーカー削除に失敗しました', error);
        alert('メーカー削除中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    },
    
    // 表示順更新
    async updateDisplayOrder(items) {
      try {
        showLoading();
        const makerIds = items.map(item => item.id);
        await service.updateMakerDisplayOrder(makerIds);
      } catch (error) {
        console.error('表示順の更新に失敗しました', error);
        alert('表示順の更新中にエラーが発生しました。');
      } finally {
        await this.fetchMakers();
        hideLoading();
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
}
.card-body {
  margin: 5px;
}
</style>
